/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: OrdersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

import { OrdersData, OrdersService }  from './Orders.service';
import { ShippersData, ShippersService } from '../Shippers/Shippers.service';
import { EmployeesData, EmployeesService } from '../Employees/Employees.service';


@Component({
  selector: 'OrdersSearch',
  template: require('./OrdersSearch.component.html'),
  providers: [OrdersService
	, ShippersService, EmployeesService
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(100%)'
        }),
        animate('0.9s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class OrdersSearchComponent implements OnInit {
	@Output() filterCriteria = new EventEmitter<string>();
	
	/* Animation for Search section */
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objOrders: OrdersData;
	errorMessage: string;
	messages: string[];
	filterExpression: string;
	showSearch: boolean;

	// Lookup Arrays
	
	ShippersList: ShippersData[];
	EmployeesList: EmployeesData[];

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private OrdersService: OrdersService
			, private  ShippersService:  ShippersService
			, private  EmployeesService:  EmployeesService

	) {
		// this.id = parseInt(params.get('id'));
		this.objOrders = new OrdersData();
		/* Initialize Lookup field values
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.filterCriteria = new EventEmitter<string>();
	}

	ngOnInit() {
		// Getting lookup data
		this.getLookups();
	}
	
	clearCriteria() {
		/* To empty values in textbox and dropdown lists
		this.objProducts.ProductName = '';
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.objOrders = new OrdersData();
		this.filterExpression = '';
		event.preventDefault();
		console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}
	
	onExpandCollapse()
	{
		this.showSearch = !this.showSearch;
	}
	
	searchProducts() {
		// Updating filterExpression on Search button click
		this.filterExpression = '';
		
		if (this.objOrders.OrderID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND OrderID = " + this.objOrders.OrderID;
			else
				this.filterExpression = "OrderID = " + this.objOrders.OrderID;
		}
		if (this.objOrders.CustomerID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CustomerID like '%" + this.objOrders.CustomerID + "%'";
			else
				this.filterExpression = "CustomerID like '%" + this.objOrders.CustomerID + "%'";
		}
		if (this.objOrders.EmployeeID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND EmployeeID = " + this.objOrders.EmployeeID;
			else
				this.filterExpression = "EmployeeID = " + this.objOrders.EmployeeID;
		}
		if (this.objOrders.ShipVia)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipVia = " + this.objOrders.ShipVia;
			else
				this.filterExpression = "ShipVia = " + this.objOrders.ShipVia;
		}
		if (this.objOrders.Freight)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Freight = " + this.objOrders.Freight;
			else
				this.filterExpression = "Freight = " + this.objOrders.Freight;
		}
		if (this.objOrders.ShipName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipName like '%" + this.objOrders.ShipName + "%'";
			else
				this.filterExpression = "ShipName like '%" + this.objOrders.ShipName + "%'";
		}
		if (this.objOrders.ShipAddress)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipAddress like '%" + this.objOrders.ShipAddress + "%'";
			else
				this.filterExpression = "ShipAddress like '%" + this.objOrders.ShipAddress + "%'";
		}
		if (this.objOrders.ShipCity)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipCity like '%" + this.objOrders.ShipCity + "%'";
			else
				this.filterExpression = "ShipCity like '%" + this.objOrders.ShipCity + "%'";
		}
		if (this.objOrders.ShipRegion)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipRegion like '%" + this.objOrders.ShipRegion + "%'";
			else
				this.filterExpression = "ShipRegion like '%" + this.objOrders.ShipRegion + "%'";
		}
		if (this.objOrders.ShipPostalCode)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipPostalCode like '%" + this.objOrders.ShipPostalCode + "%'";
			else
				this.filterExpression = "ShipPostalCode like '%" + this.objOrders.ShipPostalCode + "%'";
		}
		if (this.objOrders.ShipCountry)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipCountry like '%" + this.objOrders.ShipCountry + "%'";
			else
				this.filterExpression = "ShipCountry like '%" + this.objOrders.ShipCountry + "%'";
		}

		
		/* Build Search here
		if (this.objProducts.ProductName)
		{
			this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
		}
		if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
			else
				this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
		}
		if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
			else
				this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
		}
		*/
		event.preventDefault();
    	console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}


	// Get Lookup List for Shippers
    getShippers() {
		this.ShippersService.getAll().subscribe(records => this.ShippersList=records);
    }
	// Get Lookup List for Employees
    getEmployees() {
		this.EmployeesService.getAll().subscribe(records => this.EmployeesList=records);
    }

	getLookups() {

        this.getShippers();
        this.getEmployees();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Orders/OrdersSearch.component.ts